import { memo } from 'react'

import { ItemType } from '@inno-sdks/files'
import cn from 'classnames'

import { InlineNameInput } from '../../../InlineNameInput'
import { FolderViewItemName } from '../Name'
import styles from './NameSlot.module.scss'
import { NameSlotProps } from './NameSlot.types'

export const NameSlot = memo<NameSlotProps>(
  ({ item, displayName, isRenaming, onSubmit, onCancel }) => {
    const fileExtension =
      item.type === ItemType.File ? item.metaData.extension : undefined
    const itemWithDisplayName = displayName
      ? { ...item, name: displayName }
      : item

    return (
      <div className={styles.nameSlot}>
        <div
          className={cn(styles.nameContent, {
            [styles.isHidden]: isRenaming
          })}
        >
          <FolderViewItemName item={itemWithDisplayName} />
        </div>
        {isRenaming && (
          <InlineNameInput
            initialValue={item.name}
            extension={fileExtension}
            onSubmit={onSubmit}
            onCancel={onCancel}
          />
        )}
      </div>
    )
  }
)
